module.exports = __webpack_public_path__ + "img/TailWing-Assembly.d636ef2b.jpg";